var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShortlink = function SvgShortlink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shortlink_svg2__a",
    x1: -54.7,
    x2: 117.2,
    y1: 76,
    y2: -15.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlink_svg2__a",
    id: "shortlink_svg2__b",
    x1: -46.7,
    x2: 125.2,
    y1: 91.1,
    y2: -0.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlink_svg2__a",
    id: "shortlink_svg2__c",
    x1: -55.3,
    x2: 116.6,
    y1: 75,
    y2: -16.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlink_svg2__a",
    id: "shortlink_svg2__d",
    x1: -28.4,
    x2: 143.5,
    y1: 125.5,
    y2: 34.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlink_svg2__a",
    id: "shortlink_svg2__e",
    x1: -22.1,
    x2: 149.8,
    y1: 137.5,
    y2: 46.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlink_svg2__a",
    id: "shortlink_svg2__f",
    x1: -25.2,
    x2: 146.6,
    y1: 131.5,
    y2: 40.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#shortlink_svg2__a",
    id: "shortlink_svg2__g",
    x1: 19.4,
    x2: 191.3,
    y1: 215.6,
    y2: 124.3
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M37 42.9c-1.5 0-3-.6-4.1-1.7L20.2 28.5c-2.3-2.3-2.3-6 0-8.3s6-2.3 8.3 0l12.7 12.7c2.3 2.3 2.3 6 0 8.3s-2.6 1.7-4.1 1.7Z",
    style: {
      fill: "url(#shortlink_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3 66.7c-.5 0-1 0-1.5-.2L4.4 61.9c-3.1-.8-5-4-4.2-7.2.8-3.1 4-5 7.2-4.2l17.4 4.6c3.1.8 5 4 4.2 7.2-.7 2.6-3.1 4.4-5.7 4.4",
    style: {
      strokeWidth: 0,
      fill: "url(#shortlink_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9 29.1c-2.6 0-5-1.7-5.7-4.4L50.6 7.3c-.8-3.1 1-6.3 4.2-7.2 3.1-.8 6.3 1 7.2 4.2l4.6 17.4c.8 3.1-1 6.3-4.2 7.2-.5.1-1 .2-1.5.2",
    style: {
      strokeWidth: 0,
      fill: "url(#shortlink_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.6 92.1c-1.5 0-3-.6-4.1-1.7-2.3-2.3-2.3-6 0-8.3l11.6-11.6c3.8-3.8 5.9-8.8 5.9-14.2s-2.1-10.4-5.9-14.2c-7.8-7.8-20.5-7.8-28.3 0L72.2 53.7c-2.3 2.3-6 2.3-8.3 0s-2.3-6 0-8.3l11.6-11.6c12.4-12.4 32.5-12.4 44.9 0 6 6 9.3 14 9.3 22.5s-3.3 16.5-9.3 22.4l-11.6 11.6c-1.1 1.1-2.6 1.7-4.1 1.7Z",
    style: {
      strokeWidth: 0,
      fill: "url(#shortlink_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4 129.6c-8.1 0-16.3-3.1-22.5-9.3-6-6-9.3-14-9.3-22.5s3.3-16.5 9.3-22.4l11.6-11.6c2.3-2.3 6-2.3 8.3 0s2.3 6 0 8.3L42.2 83.7c-3.8 3.8-5.9 8.8-5.9 14.2s2.1 10.4 5.9 14.2c7.8 7.8 20.5 7.8 28.3 0l11.6-11.6c2.3-2.3 6-2.3 8.3 0s2.3 6 0 8.3l-11.6 11.6c-6.2 6.2-14.3 9.3-22.5 9.3Z",
    style: {
      strokeWidth: 0,
      fill: "url(#shortlink_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9 99.2c-1.5 0-3-.6-4.1-1.7-2.3-2.3-2.3-6 0-8.3l32.4-32.4c2.3-2.3 6-2.3 8.3 0s2.3 6 0 8.3L65.1 97.5c-1.1 1.1-2.6 1.7-4.1 1.7Z",
    style: {
      strokeWidth: 0,
      fill: "url(#shortlink_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8 200h-.9c-2.3-.3-4.2-2.1-4.8-4.4l-20.9-82.2c-.5-2 0-4.1 1.5-5.6s3.6-2 5.6-1.5l82.2 20.9c2.3.6 4 2.5 4.4 4.8.3 2.3-.7 4.7-2.8 5.9l-19.7 11.9 10.9 14c5.5 7 4.9 17-1.4 23.3s-16.3 6.9-23.3 1.4l-14-10.9-11.9 19.7c-1.1 1.8-3 2.8-5 2.8Zm15.3-37c1.3 0 2.6.4 3.6 1.2l19.2 15c2.4 1.8 5.7 1.6 7.8-.5s2.3-5.5.5-7.8l-15-19.2c-1-1.3-1.4-3-1.1-4.7a6.2 6.2 0 0 1 2.7-4l13.3-8-59.1-15 15 59.1 8-13.3c.9-1.4 2.3-2.4 4-2.7h1.1Z",
    style: {
      strokeWidth: 0,
      fill: "url(#shortlink_svg2__g)"
    }
  }));
};
export default SvgShortlink;